import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FaviconService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  setFavicon(faviconSrc: string): void {
    const existingLinks = document.querySelectorAll('link[rel*=\'icon\']');
    existingLinks.forEach((linkElement) => linkElement.remove());

    const link: HTMLLinkElement = this.renderer.createElement('link');
    this.renderer.setAttribute(link, 'rel', 'icon');
    this.renderer.setAttribute(link, 'type', 'image/x-icon');
    this.renderer.setAttribute(link, 'href', faviconSrc);
    document.head.appendChild(link);

    const shortcutLink: HTMLLinkElement = this.renderer.createElement('link');
    this.renderer.setAttribute(shortcutLink, 'rel', 'shortcut icon');
    this.renderer.setAttribute(shortcutLink, 'type', 'image/x-icon');
    this.renderer.setAttribute(shortcutLink, 'href', faviconSrc);
    document.head.appendChild(shortcutLink);

    localStorage.setItem('favicon_url', faviconSrc);
  }
}
